
	import { ref, onMounted, computed } from 'vue';
	import { ISupportCategory, ISupportCategoryTopLevel } from "VueInterfaces/Interfaces";
	import SupportCategoriesCard from "VueComponents/SupportCategories/SupportCategoriesCard.vue";
	import { ISupportCategoriesAppTranslations } from "VueInterfaces/Interfaces";
	import { Helpers } from "Helpers/helpers";

	export default {
		name: "SupportCategories",
		components: {
			SupportCategoriesCard
		},
		setup() {
			const supportCategories = ref<ISupportCategory[]>([]);
			const currentCategory = ref<ISupportCategory[]>([]);
			const categoryStack = ref([]);
			const searchInput = ref(null);
			const supportCategoryError = ref(false);
			const translations = ref<ISupportCategoriesAppTranslations>({});

			const getSupportCategoriesData = async () => {
				let categoryDiv = document.getElementById('productCategoriesData');
				let categoriesData:ISupportCategoryTopLevel = JSON.parse(categoryDiv.getAttribute('data-page-data'));
				supportCategories.value = categoriesData.SupportCategories;
				currentCategory.value = categoriesData.SupportCategories;
			};

			const sortedCategories = computed(() => {
				return currentCategory.value.slice().sort((a, b) => {
					return a.SortOrder - b.SortOrder;
				});
			});

			const setCurrentCategory = (childCategories) => {
				currentCategory.value = childCategories
			};

			const checkValue = () => {
				let inputValue = (searchInput.value).value;

				if (inputValue.length) {
					this.supportCategoryError = false;
				}
			};

			const enterCategory = (currentCategory, childCategories) => {
				categoryStack.value.push(currentCategory);
				setCurrentCategory(childCategories);
			};

			const goBack = () => {
				setCurrentCategory(categoryStack.value.pop());
			};

			const runLookup = () => {
				let inputValue = (searchInput.value).value;

				if ((searchInput.value).value) {
					window.location.href = Helpers.getLanguagePrefixedUrl(`/search?FilterCriteria.Query=${inputValue}&FilterCriteria.Tab=products`);
				} else if (inputValue.length == 0) {
					supportCategoryError.value = true;
				}
			};

			onMounted(() => {
				getSupportCategoriesData();
				translations.value = getTranslations();
			});

			const getTranslations = () => {
				let supportCategoryDiv = document.getElementById('productCategoriesData');
				return JSON.parse(supportCategoryDiv.getAttribute('data-translations'));
			};

			return {
				supportCategories,
				currentCategory,
				sortedCategories,
				translations,
				categoryStack,
				getSupportCategoriesData,
				setCurrentCategory,
				enterCategory,
				goBack,
				runLookup,
				supportCategoryError,
				getTranslations,
				searchInput,
				checkValue
			};
		},
	};
